import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { CharacteristicsSetService } from './api/characteristicsSet.service';
import { HeaderSetService } from './api/headerSet.service';
import { OperationsSetService } from './api/operationsSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class TaskListApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<TaskListApiModule> {
        return {
            ngModule: TaskListApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: TaskListApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('TaskListApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
